// src/api/mockData.js
// 模拟数据
const mockPosts = [
  {
    id: 1,
    title: 'React Hooks 的使用技巧',
    author: '张三',
    date: '2024-01-15T10:00:00Z',
    tags: ['React', 'JavaScript', 'Hooks'],
    summary: '本文介绍了 React Hooks 的基本用法和一些实用技巧，帮助你更好地使用 Hooks。',
    content: '# React Hooks 使用技巧\n\nReact Hooks 是 React 16.8 版本引入的新特性，它允许你在不编写 class 组件的情况下使用 state 和其他 React 特性。\n\n## useState Hook\n\nuseState 是最常用的 Hook，用于在函数组件中添加状态。\n\n```javascript\nimport React, { useState } from \'react\';\n\nfunction Counter() {\n  const [count, setCount] = useState(0);\n\n  return (\n    <div>\n      <p>计数: {count}</p>\n      <button onClick={() => setCount(count + 1)}>增加</button>\n    </div>\n  );\n}\n```',
    likes: 120,
    views: 850,
    comments: 25
  },
  {
    id: 2,
    title: 'JavaScript 异步编程详解',
    author: '李四',
    date: '2024-01-10T14:30:00Z',
    tags: ['JavaScript', 'Async', 'Promise'],
    summary: '深入探讨 JavaScript 中异步编程的各种方式，包括回调函数、Promise 和 async/await。',
    content: '# JavaScript 异步编程详解\n\nJavaScript 是单线程语言，但通过事件循环机制实现了异步编程。\n\n## 回调函数\n\n最早的异步编程方式是使用回调函数。\n\n```javascript\nfunction fetchData(callback) {\n  setTimeout(() => {\n    callback(\'数据加载完成\');\n  }, 1000);\n}\n\nfetchData((data) => {\n  console.log(data);\n});\n```',
    likes: 95,
    views: 720,
    comments: 18
  },
  {
    id: 3,
    title: 'CSS Grid 布局实战',
    author: '王五',
    date: '2024-01-05T09:15:00Z',
    tags: ['CSS', 'Grid', 'Layout'],
    summary: '通过实际案例学习 CSS Grid 布局的使用方法，创建响应式网页布局。',
    content: '# CSS Grid 布局实战\n\nCSS Grid 是现代网页布局的强大工具，可以轻松创建复杂的二维布局。\n\n## 基本概念\n\n- **网格容器**：应用 grid 布局的父元素\n- **网格项**：网格容器中的子元素\n- **网格线**：网格的行和列边界\n\n```css\n.container {\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  grid-template-rows: auto 1fr auto;\n  gap: 10px;\n}\n\n.item {\n  background-color: #f0f0f0;\n  padding: 20px;\n}\n```',
    likes: 150,
    views: 980,
    comments: 32
  }
];

const mockAboutInfo = {
  name: '张三',
  avatar: '/default-avatar.png',
  intro: '前端开发者，热爱技术分享',
  details: '欢迎来到我的博客！',
  email: 'zhangsan@example.com',
  techStack: 'React, JavaScript, Node.js',
  hobbies: '阅读、旅行、摄影',
  github: 'https://github.com/zhangsan',
  personalHomepage: 'https://zhangsan.com'
};

// API 方法
export const getRecentPosts = async () => {
  // 模拟网络请求延迟
  await new Promise(resolve => setTimeout(resolve, 500));
  return mockPosts.slice(0, 3); // 返回最新的3篇文章
};

export const getArchivePosts = async () => {
  // 模拟网络请求延迟
  await new Promise(resolve => setTimeout(resolve, 500));
  return mockPosts; // 返回所有文章
};

export const getPostById = async (id) => {
  // 模拟网络请求延迟
  await new Promise(resolve => setTimeout(resolve, 500));
  
  const post = mockPosts.find(p => p.id === parseInt(id));
  if (!post) {
    throw new Error('文章不存在');
  }
  return post;
};

export const createPost = async (postData) => {
  // 模拟网络请求延迟
  await new Promise(resolve => setTimeout(resolve, 800));
  
  // 在实际应用中，这里应该发送 POST 请求到服务器
  // 这里只是模拟返回成功结果
  return { success: true, data: { ...postData, id: Date.now(), date: new Date().toISOString() } };
};

export const updatePost = async (postData) => {
  // 模拟网络请求延迟
  await new Promise(resolve => setTimeout(resolve, 800));
  
  // 在实际应用中，这里应该发送 PUT 请求到服务器
  // 这里只是模拟返回成功结果
  return { success: true, data: postData };
};

export const getAboutInfo = async () => {
  // 模拟网络请求延迟
  await new Promise(resolve => setTimeout(resolve, 300));
  return mockAboutInfo;
};

export const updateAboutInfo = async (info) => {
  // 模拟网络请求延迟
  await new Promise(resolve => setTimeout(resolve, 300));
  
  // 在实际应用中，这里应该发送 PUT 请求到服务器
  // 这里只是模拟返回成功结果
  return { success: true, data: info };
};